export default class FieldValidationModel {
	public field: string = '';
	public filled: boolean = false;
	//This message must always be a i18n string
	public message: string = '';
	public data: any = {};
}
